/**
 * Prefetch helpers — import from here in Layout/Dashboard/AuthContext (not from lazyChunks + same file as App).
 */
import {
  dashboardChunk,
  projectChunk,
  settingsChunk,
  tokenGroupChunk,
  logsChunk,
  knowledgeBaseChunk,
  warmupChunk,
  exchangeDistributorChunk,
  exchangeDistributorSettingsChunk,
  cexDashboardChunk,
  cexTokensChunk,
  cexTokenGroupChunk,
  cexExchangesChunk,
  cexAlgorithmsChunk,
  cexBotsChunk,
} from '../pages/lazyChunks.js'

function runAfterNextPaint(fn) {
  if (typeof requestAnimationFrame !== 'undefined') {
    requestAnimationFrame(() => requestAnimationFrame(fn))
  } else {
    setTimeout(fn, 0)
  }
}

/**
 * Load only the chunk for the current URL. Pulling every route at login
 * (dashboard+project+settings+logs+warmup+distributor+KB+CEX) dominated network
 * and the main thread — first interaction felt slow.
 */
export function prefetchAppRouteChunks() {
  runAfterNextPaint(() => {
    if (typeof window === 'undefined') return
    prefetchRouteForPath(window.location.pathname)
  })
}

export function prefetchRouteForPath(pathname) {
  const p = String(pathname || '').split(/[?#]/)[0] || '/'

  if (p === '/' || p === '') {
    void dashboardChunk()
    return
  }
  if (p.startsWith('/project/group/')) {
    void tokenGroupChunk()
    return
  }
  if (p === '/project' || (p.startsWith('/project') && !p.includes('/group/'))) {
    void projectChunk()
    void tokenGroupChunk()
    return
  }
  if (p.startsWith('/knowledge')) {
    void knowledgeBaseChunk()
    return
  }
  if (p.startsWith('/logs')) {
    void logsChunk()
    return
  }
  if (p.startsWith('/warmup/exchange-distributor')) {
    void exchangeDistributorChunk()
    void exchangeDistributorSettingsChunk()
    void warmupChunk()
    return
  }
  if (p.startsWith('/warmup')) {
    void warmupChunk()
    void exchangeDistributorChunk()
    void exchangeDistributorSettingsChunk()
    return
  }
  if (p.startsWith('/settings') || p.startsWith('/account')) {
    void settingsChunk()
    return
  }
  if (p === '/cex' || p === '/cex/') {
    void cexDashboardChunk()
    return
  }
  if (p.startsWith('/cex/tokens/')) {
    void cexTokenGroupChunk()
    return
  }
  if (p.startsWith('/cex/tokens')) {
    void cexTokensChunk()
    void cexTokenGroupChunk()
    return
  }
  if (p.startsWith('/cex/exchanges')) {
    void cexExchangesChunk()
    return
  }
  if (p.startsWith('/cex/algorithms')) {
    void cexAlgorithmsChunk()
    return
  }
  if (p.startsWith('/cex/bots')) {
    void cexBotsChunk()
    return
  }
}
